import { useState } from 'react';

type CustomSliderProps = {
  minimumValue: number;
  maximumValue: number;
  defaultValue?: number;
  step: number;
  onValueChange: (_value: number) => void;
};

export const CustomSlider = ({ step, minimumValue, maximumValue, defaultValue, onValueChange }: CustomSliderProps) => {
  const [value, setValue] = useState(defaultValue);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const newVal = parseFloat(event.target.value);
    setValue(newVal);
    onValueChange(newVal);
  };
  return (
    <div>
      <input
        type="range"
        value={value}
        min={minimumValue}
        max={maximumValue}
        step={step}
        onChange={handleChange}
        className="w-full cursor-pointer accent-orange-600"
      />
      {maximumValue > 30 ? (
        <div className="flex flex-row justify-between">
          <div>{minimumValue}min</div>
          <div>{maximumValue}min</div>
        </div>
      ) : (
        <div className="flex flex-row justify-between">
          <div>{minimumValue}min</div>
          <div>{maximumValue}min</div>
        </div>
      )}
    </div>
  );
};
